import type { HttpClient } from '@wix/http-client'
import type { AppApi } from '@wix/wix-data-client-common'
import { updateDataModeValues } from '@wix/wix-data-client-common'
import type {
  DataSettings,
  EditorSDK,
  Logger,
} from '@wix/wix-data-client-common-standalone'
import { installCMSAutomationsApp } from '../utils/installCMSAutomationsApp'

type Params = {
  previousDataSettings: Required<DataSettings> | null
  nextDataSettings: Required<DataSettings>
  logger: Logger
  editorSdkProxy: EditorSDK
  httpClient: HttpClient
  finalAppApiPromise: Promise<AppApi>
  metaSiteId: string
}

export const onDataSettingsChange = ({
  previousDataSettings,
  nextDataSettings,
  logger,
  editorSdkProxy,
  httpClient,
  finalAppApiPromise,
  metaSiteId,
}: Params) => {
  if (
    previousDataSettings?.contentManagerEnabled !==
    nextDataSettings.contentManagerEnabled
  ) {
    updateDataModeValues({
      logger,
      editorSdkProxy,
      dataMode: nextDataSettings.contentManagerEnabled,
    })
    if (nextDataSettings.contentManagerEnabled) {
      installCMSAutomationsApp({
        logger,
        httpClient,
        metaSiteId,
      })
    }
  }
  if (
    previousDataSettings?.sandboxEnabled !== nextDataSettings.sandboxEnabled
  ) {
    finalAppApiPromise
      .then(api => api.refreshCollectionItemCounts())
      .catch(error => {
        logger.error(
          new Error('Failed to refresh collection item counts', {
            cause: error,
          }),
        )
      })
  }
}
